/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentRunsGetAgentRun } from "../../funcs/agentRunsGetAgentRun.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAgentRunRequest$inboundSchema,
};

export const tool$agentRunsGetAgentRun: ToolDefinition<typeof args> = {
  name: "agent-runs-get-agent-run",
  description: `Retrieve an agent run`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentRunsGetAgentRun(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
